import React, { useState } from 'react';
import Header from './Header';
import Sidebar, { MenuItem } from './Sidebar';
import Footer from './Footer';
import './MainLayout.css';

export interface MainLayoutProps {
  children: React.ReactNode;
  menuItems?: MenuItem[];
  showSidebar?: boolean;
  showFooter?: boolean;
  userEmail?: string;
  onLogout?: () => void;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  menuItems = [],
  showSidebar = true,
  showFooter = true,
  userEmail,
  onLogout,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    // Only close on mobile
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="main-layout">
      <Header
        onMenuToggle={toggleSidebar}
        showMenuButton={showSidebar}
        userEmail={userEmail}
        onLogout={onLogout}
      />

      <div className="layout-body">
        {showSidebar && (
          <Sidebar isOpen={isSidebarOpen} menuItems={menuItems} onClose={closeSidebar} />
        )}

        <main
          className={`layout-main ${showSidebar ? 'with-sidebar' : ''} ${
            showSidebar && !isSidebarOpen ? 'sidebar-collapsed' : ''
          }`}
        >
          <div className="main-content">{children}</div>

          {showFooter && <Footer />}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
